// extracted by mini-css-extract-plugin
export default {"a11yFocus":"s_jnm2","a11YFocus":"s_jnm2","submitButton":"jr4wAn","subtitleBr":"sA5ViU"};